module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Git3-41006ee4f2bc70cbfaea1b590509f8ac.svg";